/**
 * NeedsReviewReportsPage
 *
 * Reports with no report type: placeholders, test records and misfiled sources
 * that the classifier marks as needs review, plus reports it has not
 * classified yet. The reports context's fetchPage requests them with the API's
 * "unclassified" reportType filter, based on the "needs-review" sidebar
 * option; the page itself is a standard table view.
 */

import ReportsShell from "@/components/reports/ReportsShell"
import ReportsTable, { buildReportFilterOptions } from "@/components/reports/ReportsTable"
import { useReportsPage, ReportsPage } from "@/components/reports/useReportsPage"
import { FilterOption } from "@/components/shared/TableFiltersSelector"
import { NEEDS_REVIEW_LABEL } from "@/services/reportsService"

/** Browser tab title and page heading. */
const PAGE_TITLE: string = NEEDS_REVIEW_LABEL

/** Short description shown under the page heading. */
const PAGE_DESCRIPTION: string =
  "Reports without a report type: placeholders, test records, misfiled sources, and reports not yet classified"

/**
 * The status filter options. They take no inputs, so they are built once at
 * module load rather than on every render.
 */
const FILTER_OPTIONS: FilterOption[] = buildReportFilterOptions()

/**
 * The Needs Review reports page.
 *
 * @returns The rendered page element.
 */
export default function NeedsReviewReportsPage(): React.JSX.Element {
  const page: ReportsPage = useReportsPage({ sidebarOption: "needs-review" })

  return (
    <ReportsShell title={PAGE_TITLE} description={PAGE_DESCRIPTION} showDetailsPanel>
      <ReportsTable page={page} filterOptions={FILTER_OPTIONS} visibleColumns={page.visibleColumns} />
    </ReportsShell>
  )
}
